import Vue from 'vue'
import Router from 'vue-router'
import adLayout from '@/layout/ad'
import usLayout from '@/layout/us'

Vue.use(Router)

export const constantRoutes = [
  {
    path: '/',
    redirect: '/home'
  },
  {
    path: '/ad',
    redirect: '/ad/user'
  },
]

/**
 * permissionRoutes
 * a base page that have permission requirements
 */
export const permissionRoutes = [
  {
    path: '/',
    component: usLayout,
    children: [
      {
        name: 'home',
        path: '/home',
        hidden: true,
        component: () => import('@/views/us/home'),
        meta: {
          title: '首页'
        }
      },
      {
        name: 'exam_status',
        path: '/exam_status',
        hidden: true,
        component: () => import('@/views/us/exam-status'),
        meta: {
          title: '成绩状态'
        }
      },
      {
        name: 'grade_detail',
        path: '/grade_detail',
        hidden: true,
        component: () => import('@/views/us/grade-detail'),
        meta: {
          title: '成绩详情'
        }
      },
      {
        name: 'exam_history',
        path: '/exam_history',
        hidden: true,
        component: () => import('@/views/us/exam-history'),
        meta: {
          title: '历次比赛'
        }
      },
      {
        name: 'user_list',
        path: '/user_list',
        hidden: true,
        component: () => import('@/views/us/user-list'),
        meta: {
          title: '学生成绩状态'
        }
      },
      {
        name: 'exam_list',
        path: '/exam_list',
        hidden: true,
        component: () => import('@/views/us/exam-list'),
        meta: {
          title: '学生历次比赛'
        }
      },
      {
        name: 'final_exam_list',
        path: '/final_exam_list',
        hidden: true,
        component: () => import('@/views/us/final_exam_list'),
        meta: {
          title: '终测成绩'
        }
      },
      {
        name: 'final_exam',
        path: '/final_exam',
        hidden: true,
        component: () => import('@/views/us/final_exam'),
        meta: {
          title: '终测成绩'
        }
      },
    ]
  },
  {
    path: '/ad',
    component: adLayout,
    children: [
      {
        name: 'user',
        path: '/ad/user',
        component: () => import('@/views/ad/user'),
        meta: {
          title: '用户管理'
        }
      },
      {
        name: 'class',
        path: '/ad/class',
        component: () => import('@/views/ad/class_grade'),
        meta: {
          title: '班级管理'
        }
      },
      {
        name: 'exam',
        path: '/ad/exam',
        component: () => import('@/views/ad/exam'),
        meta: {
          title: '考试管理'
        }
      },
      {
        name: 'final_exam',
        path: '/ad/final_exam',
        component: () => import('@/views/ad/final_exam'),
        meta: {
          title: 'ALL STAR-Final门户'
        }
      },
      {
        name: 'setting',
        path: '/ad/setting',
        component: () => import('@/views/ad/setting'),
        meta: {
          title: '系统设置'
        }
      },
    ]
  },
  
]


const createRouter = () => new Router({
  mode: 'history',
  scrollBehavior: () => ({ y: 0 }),
  routes: constantRoutes
})

const router = createRouter()

export default router
